var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('static-contact-us'),_c('static-footer',{attrs:{"pageObj":_vm.contactPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }